import { FC } from "react";
import { ImgProps, Img } from "@chakra-ui/react";
import logo from "assets/images/maf-logo.png";

const Logo: FC<ImgProps> = (props) => {
  return <Img src={logo} {...props} />;
};

export default Logo;
